import * as React from 'react';
import { AlgoliaAnalytics } from '@grandvisionhq/analytics';
import { ProductListingBlock } from '../../../../lib-components/ProductListingBlock/ProductListingBlock.js';

const ProductListingBlockWrapper = ({ product: product1 , index: index1 , reimbursableLogos , addImpressionEvent , pushProductClickToDatalayer , isPriceSuffixEnabled , indexName ,  })=>{
    const onProductBlockClick = React.useCallback((product, index, handleSearchAnalytics)=>{
        handleSearchAnalytics(product.objectID, index);
        pushProductClickToDatalayer(product, index);
    }, [
        pushProductClickToDatalayer
    ]);
    return /*#__PURE__*/ React.createElement(AlgoliaAnalytics, null, (handleSearchAnalytics)=>{
        return /*#__PURE__*/ React.createElement(ProductListingBlock, {
            className: "product-listing-product-block",
            listingProduct: product1,
            onImpression: ()=>{
                return addImpressionEvent === null || addImpressionEvent === void 0 ? void 0 : addImpressionEvent(product1, index1, indexName);
            },
            onInteraction: ()=>onProductBlockClick(product1, index1, handleSearchAnalytics)
            ,
            reimbursableLogos: reimbursableLogos,
            productLocation: "plp",
            isPriceSuffixEnabled: isPriceSuffixEnabled
        });
    });
};

export { ProductListingBlockWrapper };
//# sourceMappingURL=ProductListingBlockWrapper.js.map
